import { render, staticRenderFns } from "./email-update-popup.html?vue&type=template&id=5a686871&scoped=true&external"
import script from "./email-update-popup.js?vue&type=script&lang=js&external"
export * from "./email-update-popup.js?vue&type=script&lang=js&external"
import style0 from "./email-update-popup.scss?vue&type=style&index=0&id=5a686871&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a686871",
  null
  
)

export default component.exports